<template>
<section>

    <div v-if="updatehouseDetails" class="">
        <div class="">
            <div class="">
                <div class=""></div>
                <div id="details" class="overlay">
                    <div class="overlay_inner">
                        <div class="row form-modal">
                            <h4 class="text-center">Segregation Waste Weight</h4>
                            <vue-form :state="formstate" class="formadd_scroll formadd_scroll_margin">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.totalWasteWeight)">
                                            <label>Total Waste Weight</label>
                                            <input type="text" name="totalWasteWeight" class="form-control" required readonly v-model="house.cityName" placeholder="Total Waste Weight" />
                                            <field-messages name="totalWasteWeight" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Total Waste Category is a required field</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>

                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wasteCategory1)">
                                            <label>Waste Category 1</label>
                                            <input type="text" name="wasteCategory1" class="form-control" required v-model="house.wasteCategory1" placeholder="Waste Category 1" />
                                            <field-messages name="wasteCategory1" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Waste Category 1 is a required field</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wasteCategory2)">
                                            <label>Waste Category 2</label>
                                            <input type="text" name="wasteCategory2" class="form-control" required v-model="house.wasteCategory2" placeholder="Waste Category 2" />
                                            <field-messages name="wasteCategory2" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Waste Category 2 is a required field</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wasteCategory3)">
                                            <label>Waste Category 3</label>
                                            <input type="text" name="wasteCategory3" class="form-control" required v-model="house.wasteCategory3" placeholder="Waste Category 3" />
                                            <field-messages name="wasteCategory3" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Waste Category 3 is a required field</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wasteCategory4)">
                                            <label>Waste Category 4</label>
                                            <input type="text" name="wasteCategory4" class="form-control" required v-model="house.wasteCategory4" placeholder="Waste Category 4" />
                                            <field-messages name="wasteCategory4" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Waste Category 4 is a required field</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wasteCategory5)">
                                            <label>Waste Category 5</label>
                                            <input type="text" name="wasteCategory5" class="form-control" required v-model="house.wasteCategory5" placeholder="Waste Category 5" />
                                            <field-messages name="wasteCategory5" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Waste Category 5 is a required field</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.wasteCategory6)">
                                            <label>Waste Category 6</label>
                                            <input type="text" name="wasteCategory6" class="form-control" required v-model="house.wasteCategory6" placeholder="Waste Category 6" />
                                            <field-messages name="wasteCategory6" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Waste Category 6 is a required field</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>

                            </vue-form>
                            <div class="form-actions">
                                <button @click="onClose" v-bind:class="'mr-5  btn btn-default'">
                                    Cancel
                                </button>
                                <button type="submit" @click="updateWasteWeight" :disabled="!(formstate.$dirty && formstate.$valid)" v-bind:class="'mr-2 btn gradientbt'">
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div id="details" class="row">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                    <label>City Name</label>
                                    <select required name="cityId" class="form-control" v-model="wasteSegregation.cityId" v-on:change="getCityLists($event.target.value)">
                                        <option value="" disabled>Select City Name</option>
                                        <option v-for="cityId in citys" :value="cityId.id">{{ cityId.name }}
                                        </option>
                                    </select>
                                    <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">City Name is a required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.segregationId)">
                                    <label>Segegration Plant</label>
                                    <select v-model="wasteSegregation.segregationId" required name="segregationId" class="form-control">
                                        <option value="" disabled>Select Segregation Plant</option>
                                        <option v-for="(item, index) in segregationPlant" :key="index" :value="item.id">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <field-messages name="segregationId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Segregation Plant is a required field
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>

                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.completionDate)">
                                    <label>Completion Date</label>
                                    <!-- <date-picker required id="completionDate" v-model="wasteSegregation.completionDate" lang="en" min="0" name="completionDate" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY"></date-picker> -->
                                    <date-picker @change="getListByDate" id="endDate" v-model="wasteSegregation.endDate" lang="en" name="endDate" required input-class="form-control" width="100%" valueType="format" :format="'DD-MM-YYYY'" placeholder="End date"></date-picker>
                                    <field-messages name="completionDate" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Completion Date is a required field
                                        </div>
                                        <div slot="pattern">Completion Date is invalid</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>

                    </vue-form>
                    <div class="col-sm-12 text-right">
                        <router-link :to="{ name: 'wasteSegregation' }">
                            <button class="mr-5 btn btn-default" type="button">
                                Cancel
                            </button>
                        </router-link>
                        <button class="mr-2 btn gradientbt" type="submit" @click="createWasteSegregation" :disabled="!(formstate.$dirty && formstate.$valid )" v-if="$route.params && !$route.params._id">
                            Save
                        </button>
                        <button class="btn gradientbt mr-5" type="submit" @click="updateWasteSegregation" :disabled=" !(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id">
                            Update
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <h3>Choose Transfer Point Trips</h3>
            </div>
            <!-- <div>               
                <div>
                    <div class="large-12 columns subcattable">
                        <table class="test-table">
                            <tr>
                                <th>Vehicle</th>
                                <th>Waste Weight</th>
                                <th>Driver</th>
                                <th>Action</th>
                            </tr>
                            <tr v-for="(subcat, index) in list" :key="index">
                                <td>{{ subcat.vNumber }}</td>
                                <td>{{ subcat.totalWeight }}</td>
                                <td>{{ subcat.firstName }}</td>
                                <td>
                                    <button class="button edit_del_btn">
                                        <i class="fa fa-pencil-square-o" @click="editCategory(index, subcat)"></i>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>              
            </div> -->


            <v-server-table ref="transferTripsTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
                    <template slot="beforeBody">
                        <tr v-if="loading" class="VueTables__no-results">
                            <td class="text-center" colspan="6">
                                <pulse-loader></pulse-loader>
                            </td>
                        </tr>
                    </template>
                    <!-- <template slot="action" slot-scope="props">
                        <div class="active_wrp">
                            <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>
                            <div class="py-2 text-center row">
                                <label class="toggle">
                                    <input class="toggle-checkbox" type="checkbox" :checked="props.row.isActive" @click.prevent="(e) => activateSegregationModal(props.row)" />
                                    <span class="slider"></span>
                                    <span class="labels" data-on="Active" data-off="Deactivate"></span>
                                </label>
                            </div>
                        </div>
                    </template> -->
                    
                    <template slot="wasteCollectionAreaCount" slot-scope="props">
                        <div class="active_wrp">
                            <a role="button" v-if="props.row.wasteCollectionAreaCount" v-on:click.stop="showArea(props.row)">{{ props.row.wasteCollectionAreaCount }}</a>
                            <p v-if="!props.row.wasteCollectionAreaCount">
                                {{ props.row.wasteCollectionAreaCount }}
                            </p>
                        </div>
                    </template>
                   
                </v-server-table>


            <div v-if="$route.params._id && noRecords">
                <h6> No matching records</h6>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import store from "../../../store";
import {
    formService,
    eventBus,
    wastesegregationservice,
    transportPointTripService
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";

export default {
    name: "wasteSegregationCreate",

    data() {
        return {
            updatehouseDetails: false,
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: "",
            EVENTS: EVENTS,
            formstate: {},
            wasteSegregation: {},

            oldWasteSegregation: {},

            citys: {},
            segregationPlant: {},
            list: [],
            parameters: {},
            house: {},

        };
    },
    mounted: function () {
        this.getCityList();
        this.getSegregationPlantList();
    },
    methods: {
        onClose() {
            this.updatehouseDetails = false;
        },
        updateWasteWeight() {
           
        },

        editCategory(row, subcat) {
            this.updatehouseDetails = true;
        },

        fieldClassName: formService.fieldClassName,
        getCityList() {
            this.loading = true;
            const params = {};
            let cityList = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cityList.push({
                                name: element.cityName,
                                id: element._id,
                            });
                        }
                    });
                    cityList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.citys = cityList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("citys.requestFunction-error:", error);
                    this.$snotify.error("Get citys list failed", "Error!");
                });
        },
        getSegregationPlantList() {
            this.loading = true;
            const params = {};
            let segregationList = [];
            this.$segregationDataRepository
                .list(params)
                .then((res) => {
                    this.loading = false;
                    res.data.docs.forEach((element) => {
                        if (element.isActive === true) {
                            segregationList.push({
                                name: element.plantName,
                                id: element._id,
                            });
                        }
                    });
                    segregationList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.segregationPlant = segregationList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("segregations.requestFunction-error:", error);
                    this.$snotify.error("Get segregations list failed", "Error!");
                });
        },

        getListByDate() {

            const eventData = this.wasteSegregation.endDate.split("-");
            const endDate = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
            let endDateIso = new Date(endDate).toISOString()

            this.parameters.page = 1;
            this.parameters.limit = 999;
            this.parameters.startDate = '';
            this.parameters.endDate = endDateIso;
            this.loading = false;
            let dataResp = {};
            return transportPointTripService
                .getListDate(this.parameters)
                .then((response) => {
                    response.data.SegregationTripData.forEach((element) => {
                        if (element.status == true && element.cityId._id == this.wasteSegregation.cityId && element.segregationId._id == this.wasteSegregation.segregationId) {
                            dataResp['vNumber'] = element.vehicleId.vNumber;
                            dataResp['totalWeight'] = element.totalWeight;
                            dataResp['firstName'] = element.driverId.firstName;
                            this.list.push(dataResp)
                        }

                    });
                    // this.list = dataResp;
                  

                })
                .catch((error) => {
                    this.$snotify.error("Get Primary Trip list failed", "Error!");
                });
        },

        getCityLists(value) {

        },

        getWasteSegregationt() {
            const params = {};
            return this.$segregationDataRepository
                .find(this.$route.params._id, params)
                .then((response) => {
                    this.WasteSegregation = response.data;
                    this.oldWasteSegregation = _.cloneDeep(this.wasteSegregation);
                    this.$store.dispatch(
                        "setBreadcrumbTitle",
                        this.wasteSegregation.addManager
                    );

                })
                .catch((error) => {
                    this.$snotify.error("Get segregation failed", "Error!");
                });
        },

        createWasteSegregation() {
            this.loading = true;

            return wastesegregationservice
                .addWasteSegregation(this.wasteSegregation)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The ${this.wasteSegregation} has been added successfully.`
                    );
                    this.$router.push("/segregation");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data.message == "PlantLocation already exists") {
                        var errorMessage = "Plant Location Already Exist!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else {
                        this.$snotify.error("Segregation Plant Create Failed", "Error!");
                    }

                });
        },

        clearChanges() {
            this.wasteSegregation = _.cloneDeep(this.oldWasteSegregation);
            this.formstate._reset();
        },
        updateWasteSegregation() {
            this.loading = true;

            return wastesegregationservice
                .updateWasteSegregation(this.wasteSegregation, this.oldwasteSegregation)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.formstate._reset();
                    this.oldWasteSegregation = _.cloneDeep(this.wasteSegregation);
                    this.$snotify.success(
                        `The ${this.wasteSegregation.plantName} has been updated successfully.`
                    );
                    this.$router.push("/segregation");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data.message == "PlantLocation already exists") {
                        var errorMessage = "Plant Location Already Exist!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else {
                        this.$snotify.error("Segregation Plant Create Failed", "Error!");
                    }
                });
        },
    },
    created() {
        const promises = [];
        this.loading = true;

        if (this.$route.params && this.$route.params._id) {
            promises.push(this.getWasteSegregationt());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error("Create wasteSegregation failed", "Error!");
            });
    },
    beforeDestroy() {},

    fieldClassName: function (field) {
        if (!field) {
            return "";
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return "has-success";
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return "has-danger";
        }
    },

};
</script>

<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.gradientbt {
    background: #0f6940;
    color: white;
}

.test-table {
    margin-left: 80px;
}

.gradientbt {
    background: #0f6940;
    color: white;
}

/* body {
    background-color: lightgray;
}

table {
    width: 100%;
}

td form {
    margin: 0;
    padding: 0;
}
 */

.test-table {
    margin-left: 80px;
}

.subcattable table {
    margin-left: 0px;
}

.subcattable table td,
.subcattable table th {
    border: 1px solid #f4f4f4;
}

.subcattable table tr:nth-of-type(odd) {
    background-color: #f9f9f9;
}

.subcattable table tr:hover {
    background-color: #f2fff9 !important;
}

.subcattable table tr td:last-child {
    width: 200px;
}
</style>



// WEBPACK FOOTER //
// wasteSegregationCreate.vue?f5d1480c